import { useState } from 'react'
import nodata from "../Utils/assets/img/leads_no_data_found_removebg.png"
import { DescriptionTooltip } from '../Utils/helpers/descriptionTooltip/DescriptionTooltip';
import { formatDate, getValueOrDash, putCommaInLeadsValue } from '../Utils/helpers/commonhelper';
import { Spinner } from 'react-bootstrap';

import { toast } from 'sonner';

export const ProspectsTable = ({
    data,
    type,
    permissionGrant,
    currentNavCard,
    openDetailPage,
    setSelectedPipelineId,
    isLoading = false
}) => {
    const [openRow, setOpenRow] = useState(null);

    return (
        <div
            className="p-0 pt-3 pb-3 position-relative"
            style={{
                border: "none",
                animation: "cardEntry 1s ease-out forwards",
            }}
        >
            {isLoading && (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(255,255,255,0.75)",
                        zIndex: 20,
                    }}
                >
                    <Spinner animation="border" variant="primary" />
                </div>
            )}
            <div className="table-responsive" style={{ maxHeight: "15rem", minHeight: '15rem' }}>
                <table className="table Communications listStyleForContact"
                    onMouseEnter={(e) => {
                        e.currentTarget.style.scrollbarColor = "#e0e0e0 white"
                    }}
                    style={{ scrollbarWidth: 'thin' }}>
                    <thead style={{ zIndex: 99 }}>

                        <tr>
                            <th style={{ borderRadius: 0 }}>#</th>
                            <th>Owner</th>
                            <th>Requirement</th>
                            <th>Budget</th>
                            <th>Closure Date</th>
                            <th>Pipeline</th>
                            <th>Stage</th>
                            <th>Status</th>
                            <th>
                                Created on
                            </th>
                            {
                                currentNavCard !== 'won' &&
                                <th
                                    className="lastactionTd"
                                    style={styles.lastdStyle}
                                ></th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data && data?.length !== 0 ?
                                data?.map((val, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td
                                                onClick={() => {
                                                    if (!permissionGrant?.isView) {
                                                        toast.warning("You are not authorized for this action!")
                                                        return
                                                    }
                                                    setSelectedPipelineId(val?.pipeline_id)
                                                    openDetailPage(val)
                                                }}
                                                style={{ cursor: 'pointer' }}
                                            >{val?.owner_name ? val.owner_name : "-"}</td>
                                            <td>
                                                {val?.requirement?.length >
                                                    20 ? (
                                                    <DescriptionTooltip
                                                        text={val.requirement}
                                                        maxLength={30}
                                                    />
                                                ) : (
                                                    getValueOrDash(val?.requirement)
                                                )}
                                            </td>
                                            <td>
                                                <span
                                                    className="mb-0 fs-12"
                                                    style={{
                                                        color: "#17c417 ",
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    {val.product_services ?

                                                        putCommaInLeadsValue(
                                                            typeof (JSON.parse(val?.product_services)) !== "string" ?
                                                                JSON.parse(val?.product_services)?.reduce((sum, obj) => sum + parseFloat(obj.budget || 0), 0)
                                                                : ""
                                                        )
                                                        : "-"}
                                                </span>
                                            </td>
                                            <td>{val?.expected_closure_date}</td>
                                            <td>
                                                {val?.pipeline_name}
                                            </td>
                                            <td>{val?.stage_name}</td>

                                            <td>
                                                {type === "deals" ? val.deal_status
                                                    : val.lead_status}
                                            </td>
                                            <td>
                                                {formatDate(val?.created_at)}
                                            </td>
                                            {/* {
                                                currentNavCard !== "won" &&
                                                < td
                                                    className="lastactionTd"
                                                    style={{
                                                        ...styles.lastdStyle, // spread karo object ko
                                                        zIndex: openRow === val.id ? 11 : "auto",
                                                    }}
                                                >
                                                    <div className="endTdDiv">
                                                        <Dropdown
                                                            as="div"
                                                            className="dropdownsWithoutToggle"
                                                            onToggle={(isOpen) => setOpenRow(isOpen ? val.id : null)}
                                                        >
                                                            <Dropdown.Toggle
                                                                as={Nav.Link}
                                                                className="header-link"
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={faEllipsisVertical}
                                                                    style={{
                                                                        fontSize: "15px",
                                                                        width: "20px",
                                                                        color: "#536485",
                                                                    }}
                                                                />
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu

                                                                align={"end"}
                                                                style={{
                                                                    width: "8rem",
                                                                    inset: "0px auto auto 0px",
                                                                    boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                                                                    position: "absolute",
                                                                    marginTop: "-22px",
                                                                    marginRight: '25px',
                                                                    minWidth: "3rem",
                                                                }}
                                                            >
                                                                <Dropdown.Item
                                                                    style={{
                                                                        fontSize: "12px",
                                                                        padding: "4px 21px",
                                                                    }}
                                                                    className="d-flex align-items-center btn"
                                                                    onClick={() => onEdit(val?.id)}
                                                                >
                                                                    Edit
                                                                </Dropdown.Item>
                                                                <Dropdown.Item
                                                                    style={{
                                                                        fontSize: "12px",
                                                                        padding: "4px 21px",
                                                                    }}

                                                                    className="d-flex align-items-center btn"
                                                                    onClick={() => onDelete(val?.id)}
                                                                >
                                                                    Delete
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </td>
                                            } */}
                                        </tr>
                                    );
                                })
                                :
                                <div
                                    className="d-flex justify-content-center align-items-center"
                                    style={{ position: "absolute", left: "40%" }}
                                >
                                    <img
                                        src={nodata}
                                        alt=""
                                        style={{ width: "12rem", marginTop: "0" }}
                                    />
                                </div>
                        }
                    </tbody>
                </table>
            </div>
        </div >
    )
}


const styles = {
    lastdStyle: {
        padding: "0 !important",

    },
};
